import gql from 'graphql-tag'

export const PUBLISH_PAGES = gql`
    mutation publishPages($input: [PublishItem!]!, $website: ID!) {
        publishPages(input: $input, website: $website) {
            statusCode
            success
        }
    }
`
